import { Helmet } from 'react-helmet-async';
import { useEffect, useState, useContext } from 'react';
import { enqueueSnackbar } from 'notistack';
import { useSearchParams, useParams } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { Grid } from '@mui/material';
import { getOrderSheet } from '../../../../redux/slices/orderSheet';
import { ShopView, CatalogView } from '../../../../components/dashboard/orders/new-order';
import { ShopViewProvider, ShopCartContext, ShopDataContext } from '../../../../components/dashboard/orders/new-order/_ShopViewContext';
import { getCartInfoItemQty } from '../../../../components/dashboard/orders/new-order/ordersheetUtils';

function ShopContent() {
  const [searchParams] = useSearchParams();
  const categoryId = searchParams.get('categoryId') || null;
  const dispatch = useDispatch();
  const { facilityId = '' } = useParams();
  const {
    data: { agoraCategory, items, hasNoItems, currFacilityId, cartInfo },
  } = useSelector((state) => state.orderSheet);
  const [isFetchOrderSheetLoading, setIsFetchOrderSheetLoading] = useState(false);
  const { setCart } = useContext(ShopCartContext);
  const { setData } = useContext(ShopDataContext);

  useEffect(() => {
    if (
      agoraCategory?.id !== parseInt(categoryId, 10) ||
      currFacilityId !== facilityId ||
      (!items.length && !hasNoItems)
    ) {
      setData([]);
      setCart({});
      setIsFetchOrderSheetLoading(true);
      dispatch(getOrderSheet(categoryId, facilityId))
        .catch(() => enqueueSnackbar('Failed to load order sheet', { variant: 'error' }))
        .finally(() => setIsFetchOrderSheetLoading(false));
    }
  }, [categoryId, agoraCategory, items, currFacilityId, facilityId, hasNoItems, dispatch]);

  useEffect(() => {
    setData(
      items.map((item) => ({
        ...item,
        quantity: getCartInfoItemQty(item, categoryId, cartInfo)
      }))
    );
  }, [items, cartInfo, agoraCategory]);

  return (
    <Grid item xl={12}>
      <Grid container spacing={1} direction="row" justifyContent="flex-start" alignItems="flex-start">
        {categoryId === '-1' ? (
          <CatalogView />
        ) : (
          <ShopView isFetchOrderSheetLoading={isFetchOrderSheetLoading}/>
        )}
      </Grid>
    </Grid>
  );
}

export default function Shop() {
  return (
    <>
      <Helmet>
        <title>New Order | Platform Solutions</title>
      </Helmet>
      <ShopViewProvider>
        <ShopContent />
      </ShopViewProvider>
    </>
  );
}
